module.exports = __webpack_public_path__ + "static/img/18.c69d56e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/18.png
// module id = WuGY
// module chunks = 0